<template>
	<div class="v-user-application">
		<div class="user-container" @click="openPage('infos')">
			<img :src="avatar" class="user-avatar" />
			<div class="user-infos">
				<div class="name-label">{{userName}}</div>
				<div class="email-label">{{email}}</div>
				<div class="user-level-block">
					<img src="../../assets/images/star.png" class="v-star-icon" />
					5.0
				</div>
			</div>
		</div>
		<div class="tool-container" v-for="(item,index) in menuList" :key="index">
			<div class="tool-header">{{item.title}}</div>
			<div class="tool-box">
				<div class="t-inner" v-for="(jtem,jndex) in item.sub" :key="jndex" @click="chengeMenu(jtem.url)">
					<img :src="jtem.icon" class="t-icon"></image>
					<div class="t-txt">{{jtem.title}}</div>
					<img src="../../assets/images/right3.png" class="la-right-icon" />
				</div>
			</div>
		</div>
		<div class="logout-btn" @click="handleLogout">Logout</div>
		<tabBar current="3"></tabBar>
	</div>
</template>

<script>
	import tabBar from '../../components/tabBar.vue'
	 import {logOut,queryStoreMsg} from '@/api/api'
	export default {
		components: {
			tabBar
		},
		data() {
			return {
				menuList: [{
						title: 'Dashboard',
						sub: [{
							id: 1,
							icon: require('@/assets/images/menu/index.png'),
							title: 'Dashboard',
							num: 0,
							url: '/'
						}]
					},
					{
						title: 'Product',
						sub: [{
								id: 2,
								icon: require('@/assets/images/menu/product.png'),
								title: 'Product',
								num: 0,
								url: 'product',
							},
							{
								id: 5,
								icon: require('@/assets/images/menu/kh.png'),
								title: 'Product Review',
								num: 0,
								url: 'review'
							}
						]
					},
					{
						title: 'Order List',
						sub: [{
								id: 6,
								icon: require('@/assets/images/menu/order.png'),
								title: 'Order List',
								num: 29,
								url: 'order-lists'
							},
							{
								id: 7,
								icon: require('@/assets/images/menu/tk.png'),
								title: 'Shop Level',
								num: 0,
								url: 'level'
							},
							{
								id: 15,
								icon: require('@/assets/images/menu/return.png'),
								title: 'Spread Packages',
								num: 0,
								url: 'package'
							// },
							// {
							// 	id: 8,
							// 	icon: require('@/assets/images/menu/fx.png'),
							// 	title: 'Purchase Spread Package',
							// 	num: 0,
							// 	url: 'purchase'
							}
						]
					},
					{
						title: 'Finance',
						sub: [/*{
								id: 9,
								icon: require('@/assets/images/menu/pay.png'),
								title: this.$t('menu.paymenthistory'),
								num: 0,
								url: "payLog"
							},*/
							{
								id: 10,
								icon: require('@/assets/images/menu/yj.png'),
								title: 'My Wallet',
								num: 0,
								url: 'wallet'
							},
							{
								id: 11,
								icon: require('@/assets/images/menu/message.png'),
								title: 'Conversations',
								num: 0,
								url: 'conversations'
							},
							{
								id: 13,
								icon: require('@/assets/images/menu/xyf.png'),
								title: 'Refund Request',
								num: 0,
								url: 'refund'
							},
							{
								id: 17,
								icon: require('@/assets/images/menu/ly.png'),
								title: 'Payment',
								num: 0,
								url: 'payment'
							}
						]
					},
					{
						title: 'Alliance System',
						sub: [
				
							{
								id: 18,
								icon: require('@/assets/images/menu/alliance.png'),
								title: 'Alliance Center',
								num: 0,
								url: 'alliance'
							},
						]
					},
					{
						title: 'Setting',
						sub: [
				
							{
								id: 16,
								icon: require('@/assets/images/menu/tj.png'),
								title: 'Shop Setting',
								num: 0,
								url: 'setting'
							},
							{
								id: 14,
								icon: require('@/assets/images/menu/set.png'),
								title: 'Transaction Password',
								num: 0,
								url: 'password'
							}
						]
					}
				],
				windowWidth: 0,
				windowHeight: 0,
				pixelRatio: 1,
				breakpoint: 768,
				userName:'',
				email:"",
				avatar:''
			}
		},
		mounted() {
			this.updateWindowSize();
			window.addEventListener('resize', this.updateWindowSize);
			if (!this.isMobile) {
			    this.$router.replace('/');
			}
		},
		beforeDestroy() {
		    window.removeEventListener('resize', this.updateWindowSize);
		},
		computed: {
		    isMobile() {
		        return this.windowWidth < this.breakpoint;
		    }
		},
		created() {
			//this.userName = localStorage.getItem('fullName') || '';
			this.email = localStorage.getItem('email') || '';
			this.init()
		},
		methods: {
			chengeMenu(e) {
				this.openPage(e)
			},
			handleLogout() {
			  // 清除本地存储的token
			  logOut().then(res => {
			    if (res.code == 200) {
			      // 清除本地存储的token
			      localStorage.removeItem('token');
			      localStorage.removeItem('fullName');
			      localStorage.removeItem('email');
			      // 跳转到登录页面
			      this.$router.push('/login');
			    }
			  });
			  // 跳转到登录页面
			  this.$router.push('/login');
			},
			updateWindowSize() {
			    this.windowWidth = window.innerWidth;
			    this.windowHeight = window.innerHeight;
			    this.pixelRatio = window.devicePixelRatio;
			},
			init(){
				var that = this
				var params = {}
				queryStoreMsg(params).then(res => {
					if (res.code == 200) {
						that.avatar = res.data.storeHead
						that.userName = res.data.fullName
					}
				});
			},
		},
		watch: {
		    isMobile(newVal) {
				if (!newVal) {
					this.$router.replace('/');
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/user.css");
</style>
